const regExpCharacters = /[\\^$.*+?()[\]{}|]/g;
const hasRegExpCharacters = new RegExp(regExpCharacters.source);
const escapeRegExpCharactersInString = (regExpString) => {
    if (!regExpString)
        return '';
    return hasRegExpCharacters.test(regExpString)
        ? regExpString.replace(regExpCharacters, '\\$&')
        : regExpString;
};

const interpolate = (strings, ...values) => {
    const interpolatedStrings = strings.map((str, i) => `${str}${escapeRegExpCharactersInString(values[i])}`);
    const resultingString = interpolatedStrings.join('');
    return new RegExp(resultingString);
};

const RegExpUtils = {
    interpolate,
};

export { RegExpUtils as R };
//# sourceMappingURL=index-0e1c9a05.js.map
